import React from "react";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { usePermissions } from "../../customHooks";

const FirmInfo = props => {
  const {
    infoMyCompany,
    companySel,
    fromClient
  } = props;

  const currentPermissions = useSelector(state => state.currentPermissions);

  let infoAddressCompany = infoMyCompany;
  let indirizzo = "";
  // Sono in questo caso quando entro come cliente e visualizzo i dati dei miei studi
  if (infoMyCompany.classifier === "STUDIO" && infoMyCompany.sedeLegale) {
    infoAddressCompany = infoMyCompany.sedeLegale;
  }
  indirizzo = infoAddressCompany.indirizzo ? infoAddressCompany.indirizzo : null;
  indirizzo += infoAddressCompany.cap ? ", " + infoAddressCompany.cap : null;
  indirizzo += infoAddressCompany.citta ? " - " + infoAddressCompany.citta : null;
  indirizzo += infoAddressCompany.nazione ? " (" + infoAddressCompany.nazione + ")" : null;

  const { isUploadMailPermission } = usePermissions(currentPermissions);

  return (
    <div className="firmData">
      <div className="azureFontData">{indirizzo ? indirizzo : "Non registrato"}</div>
      <div style={{ display: "flex", width: "100%" }}>
        <div className="azureFontData"><FormattedMessage id="generic.vatNumberSmall" />: </div>
        {infoMyCompany.partitaIva}
        <div className="azureFontDataCf"><FormattedMessage id="generic.fiscalCodeExtendedSmall" />: </div>
        {infoMyCompany.codiceFiscale}
      </div>
      {isUploadMailPermission && infoMyCompany.classifier === "STUDIO" && fromClient ?
        <div>
          <div style={{ display: "flex", width: "100%", marginTop: "10px", marginLeft: "20px" }}>
            <div><FontAwesomeIcon icon={["far", "envelope"]} style={{
              color: "#152935",
              fontSize: "12px",
              marginRight: "10px"
            }} />
            {"email per caricamento documenti: "}</div>
          </div>
          {<div style={{ marginLeft: "40px" }}>
            {infoMyCompany.codiceFiscale + "-" + companySel + "@cd.agyo.io"}</div>}
        </div> : null}
    </div>
  );
};

export default FirmInfo;
